/**
 * Contains a static list of unique ids for given prefixes so we can return the next one every time
 */
const identifiers = {
    default: 0
}

/**
 * provides a unique index for a given prefix
 * 
 * @param {String} prefix
 * @param {String} separator
 * @returns {Integer}
 */
const uniqueId = (prefix = 'default', separator = ':') => `${prefix}${separator}${getNextIndex(prefix)}`

/**
 * Gets the next index unique for the given prefix
 * 
 * @param {String} prefix 
 * @returns {Integer}
 */
const getNextIndex = (prefix = 'default') => identifiers[prefix] !== undefined
    ? ++identifiers[prefix]
    : (identifiers[prefix] = 1)

export default uniqueId
